const ADOBE_FEATURE_NAME = 'EmbedAdobeAnalytics';

const ADOBE_CONST_VALUES = {
    PLATFORM_NAME: 'flex',
    LANGUAGE: 'English',
    PAGE_TYPE: 'page'
};

const APP_CODE_MAPPING = {
    'PCNA-PORSCHEDRIVE': 'porschedrive',
    'VCI-AUDI_BUYER': 'audidirect',
    'VCI-VOLKSWAGEN_BUYER': 'vwdirect',
    'CHASE-CHASEM': 'maseratidirect',
    'BENTLEY-BUYER_PORTAL': 'bentleydirect',
    'FUSION-BUYER_PORTAL': 'fusiondirect',
    'POLESTAR-BUYER_PORTAL': 'polestardirect',
    'RIVIAN-BUYER_PORTAL': 'rivianrdirect',
    'MCLAREN-BUYER_PORTAL': 'mclarendirect',
    'VOLVO-BUYER-PORTAL': 'volvodealer',
    'LAMBO-BUYER_PORTAL': 'lamborghinidirect'
};

module.exports = { ADOBE_FEATURE_NAME, ADOBE_CONST_VALUES, APP_CODE_MAPPING };
